import type { AuditFileContent } from '@ifs-gcp/core/models';

/**
 * Convert JSON to UTF-8 bytes, then convert to binary string, and finally encode to base64.
 * This is to avoid encoding errors when the JSON contains special characters.
 */
export const getBtoa = (obj: AuditFileContent) => {
  const json = JSON.stringify(obj);
  const bytes = new TextEncoder().encode(json);
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
};
